import {ProcessDiagramIds} from '../../../../constants/tasks';
import {xarrowPropsType} from 'react-xarrows';

type ArrowProps = Pick<xarrowPropsType, 'start' | 'end' | 'startAnchor' | 'endAnchor'>;

export const getArrows = (formattedTasks): ArrowProps[] => {
  const countOfColumns = formattedTasks?.length;

  const initialArrow = {
    start: ProcessDiagramIds.START,
    end: formattedTasks[0].length > 1 ? `arrow_${0}` : `cArrow_${0}${0}`
  };

  return formattedTasks.reduce((acc, tasks, i) => {
    const hasParallelTasks = tasks.length > 1;
    const isLastColumn = countOfColumns - 1 === i;

    tasks.forEach((task, columnIndex) => {
      if (!hasParallelTasks) {
        return;
      }

      if (!isLastColumn) {
        acc.push({
          start: `cArrow_${columnIndex}${i}`,
          end: `aArrow_${i}`
        });
      }

      if (i !== 0) {
        acc.push({
          start: `arrow_${i}`,
          end: `cArrow_${columnIndex}${i}`,
          startAnchor: hasParallelTasks ? columnIndex === 0 ? 'top' : 'bottom' : 'auto',
          endAnchor: 'left'
        });
      }
    });

    if (hasParallelTasks) {
      if (!isLastColumn) {
        acc.push({
          start: `aArrow_${i}`,
          end: `cArrow_${0}${++i}`
        });
      }
      // TODO: ADD ARROW TO FINAL CIRCLE WHEN PROCESS FINISHED
      // isLastColumn && processEnd
      // <Xarrow {...arrowPropsInitial} start={`aArrow_${i}`} end="processEnd" />
    } else {
      if (isLastColumn) {
        // TODO: ADD ARROW TO FINAL CIRCLE WHEN PROCESS FINISHED
        // <Xarrow {...arrowPropsInitial} start={`cArrow_${0}${i}`} end="processEnd" />
      } else {
        if (formattedTasks[i + 1]?.length === 1) {
          acc.push({
            start: `cArrow_${0}${i}`,
            end: `cArrow_${0}${++i}`
          });
        }

        if (formattedTasks[i + 1]?.length > 1) {
          acc.push({
            start: `cArrow_${0}${i}`,
            end: `arrow_${++i}`
          });
        }
      }
    }

    return acc;
  }, [initialArrow]);
};
